import React, {useState, useEffect} from "react";

import ZbiorowyKomornikNadawca from "./ZbiorowyKomornikNadawca";
import ZbiorowyKomornikAdresat from "./ZbiorowyKomornikAdresat";
import ZbiorowyKomornikSaldo from "./ZbiorowyKomornikSaldo";
import ZbiorowyKomornikTable from "./ZbiorowyKomornikTable";

import { mm_rrrr_to_date, pierwszyDzienMiesiaca } from "../../../../functions/dataFormat";
import ZbiorowyKomornikOpisy from "./ZbiorowyKomornikOpisy";

const ZbiorowyWydrukA4 = props =>  {

    const { componentRef, showKomornik, przelewyRok, czynszeRok, wspolnota, mieszkaniec, adres, czynszeWspolnota, przelewyWspolnota, 
        stawkiJednorazoweInd } = props;

    const [przelewyStare, setPrzelewyStare] = useState(0);
    const [czynszeStare, setCzynszeStare] = useState(0);
    const [saldoStare, setSaldoStare] = useState(0);
    
    const [czynsze, setCzynsze] = useState([]);

    const [stawkiInd, setStawkiind] = useState([]);

    useEffect( () => {
        const g = stawkiJednorazoweInd?.filter( s => s?.id_user == showKomornik.id_user 
            && s?.grupa_numer == showKomornik.grupa_numer
            && new Date(s?.msc).getFullYear() == new Date().getFullYear()   );
        setStawkiind(g)
    },[stawkiJednorazoweInd, showKomornik])

    useEffect( () => {
        const u = czynszeWspolnota?.find( c => c?.id_user == showKomornik.id_user)?.grupy_udzial_msc;
        let g = u?.find( c => c?.id_user == showKomornik.id_user && c?.grupa_numer == showKomornik.grupa_numer)?.temp_msc;
        const len = g?.length;
        
        if (new Date(mm_rrrr_to_date(g[len-1].msc)) > new Date(pierwszyDzienMiesiaca()))
            g = g.slice(0, -1);

        setCzynsze(g)
    },[czynszeWspolnota, showKomornik])

    const [sumaCzynszeTenRok, setSumaCzynszeTenRok] = useState(0);
    const [sumaPrzelewyTenRok, setSumaPrzelewyTenRok] = useState(0);

    const przelewy_g = przelewyWspolnota?.find( p => p?.id_user == showKomornik.id_user && p?.nr_grupyUdzial == showKomornik.grupa_numer)?.przelewy;

    useEffect( () => {
        let temp = 0;
        przelewy_g?.forEach( p => {
            if (new Date(p.data_operacji).getFullYear() < new Date().getFullYear())
                temp += p.kwota; 
        });
        setPrzelewyStare(temp);
    },[przelewy_g]);

    useEffect( () => {
        let temp = 0;
        czynsze?.forEach( c => {
            if (new Date(mm_rrrr_to_date(c.msc)).getFullYear() < new Date().getFullYear())
                temp += c.czynsz_na_msc;
        });
        setCzynszeStare(temp);
    },[czynsze])

    useEffect( () => {
        setSaldoStare( przelewyStare - czynszeStare )
    },[przelewyStare, czynszeStare]);
    
    useEffect( () => {
        let temp = 0;
        czynsze?.forEach( c => {
            if (new Date(mm_rrrr_to_date(c.msc)).getFullYear() == new Date().getFullYear()) {
                temp += c?.czynsz_na_msc;
            }
        });
        setSumaCzynszeTenRok(temp);
        console.log(czynsze)
    },[czynsze]);

    useEffect( () => {
        let temp = 0;
        przelewy_g?.forEach( p => {
            if (new Date(p.data_operacji).getFullYear() == new Date().getFullYear())
                temp += p?.kwota;
        })
        setSumaPrzelewyTenRok(temp)
    },[przelewy_g])

    return (
        <div    
            style={{
                width: '21cm',
                height: '29.7cm',
                backgroundColor: 'white',
                boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
                padding: '15mm 15mm',
                boxSizing: 'border-box',
                maxWidth: '100%',
                maxHeight: '100%',
                fontSize: '12px',
                position: "relative"
            }}
            ref={componentRef ? componentRef : null}
        >
            <ZbiorowyKomornikNadawca />
            <ZbiorowyKomornikAdresat
                mieszkaniec={mieszkaniec}
                adres={adres}
            />
            <ZbiorowyKomornikTable 
                showKomornik={showKomornik}
                czynsze={czynsze}
                przelewy_g={przelewy_g}
                przelewyRok={przelewyRok}
                czynszeRok={czynszeRok}
                sumaCzynszeTenRok={sumaCzynszeTenRok}
                sumaPrzelewyTenRok={sumaPrzelewyTenRok}
                stawkiInd={stawkiInd}
                saldoStare={saldoStare}
            />
            <ZbiorowyKomornikSaldo
                czynsze={czynsze}
                przelewy_g={przelewy_g}
                saldoStare={saldoStare}
                sumaCzynszeTenRok={sumaCzynszeTenRok}
                sumaPrzelewyTenRok={sumaPrzelewyTenRok}
            />
            {
                (saldoStare !== 0 || stawkiInd?.length > 0) &&
                <ZbiorowyKomornikOpisy
                    stawkiInd={stawkiInd}
                    saldoStare={saldoStare}
                />
            }
            <div style={{
                fontSize: "10px",
                padding: "15px 0",
                position: "absolute", 
                left: "20px",
                bottom: "0"
            }}>
                Dokument wygenerowany elektronicznie z systemu BON Administrator. Nie wymaga podpisu.
            </div>
        </div>
    )
}

export default ZbiorowyWydrukA4;